import { forwardRef } from "react";

import type { SVGIconProps } from "../types";

export const PortMiniDisplayPortIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_320"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_320)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7836 11H4.17065C4.1236 11 4.07655 10.981 4.03891 10.9526L1.0941 8.79171C1.03764 8.75378 1 8.68742 1 8.61157V5.21806C1 5.09481 1.10351 5 1.22584 5H14.7836C14.9059 5 15 5.09481 15 5.21806V10.7725C15 10.8957 14.9059 11 14.7836 11ZM4.30526 10.1639H14.2582V5.74867H1.78987L1.78987 8.40217L4.30526 10.1639Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5711 9.13305C12.1655 9.13305 11.8245 8.79999 11.8061 8.40217H4.53003C4.51159 8.80924 4.17056 9.13305 3.76501 9.13305C3.34103 9.13305 3 8.79074 3 8.36516V7.63428C3 7.20871 3.34103 6.86639 3.76501 6.86639H12.5704C12.9943 6.86639 13.3354 7.20871 13.3354 7.63428V8.36516C13.3354 8.79074 12.9951 9.13305 12.5711 9.13305ZM4.30954 7.96735H12.0182C12.138 7.96735 12.2394 8.05986 12.2394 8.18014V8.36518C12.2394 8.55022 12.3868 8.69824 12.5712 8.69824C12.7555 8.69824 12.903 8.55022 12.903 8.36518V7.6343C12.903 7.44926 12.7555 7.29198 12.5712 7.29198H3.76583C3.58149 7.29198 3.43402 7.44926 3.43402 7.6343V8.36518C3.43402 8.55022 3.58149 8.69824 3.76583 8.69824C3.95018 8.69824 4.09765 8.55022 4.09765 8.36518V8.18014C4.09765 8.05987 4.18971 7.96735 4.30954 7.96735Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.48461 7.18834C4.36479 7.18834 4.26342 7.09582 4.26342 6.97555V6.47595C4.26342 6.35568 4.3648 6.26316 4.48461 6.26316C4.59522 6.26316 4.69661 6.35567 4.69661 6.47595V6.97555C4.69661 7.09582 4.59523 7.18834 4.48461 7.18834Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.15419 7.18834C6.03437 7.18834 5.93299 7.09582 5.93299 6.97555V6.47595C5.93299 6.35568 6.03437 6.26316 6.15419 6.26316C6.274 6.26316 6.36619 6.35567 6.36619 6.47595V6.97555C6.36619 7.09582 6.27401 7.18834 6.15419 7.18834Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00312 7.18834C7.88329 7.18834 7.78192 7.09582 7.78192 6.97555V6.47595C7.78192 6.35568 7.8833 6.26316 8.00312 6.26316C8.12293 6.26316 8.21511 6.35567 8.21511 6.47595V6.97555C8.21511 7.09582 8.12294 7.18834 8.00312 7.18834Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.84284 7.18834C9.72302 7.18834 9.63084 7.09582 9.63084 6.97555V6.47595C9.63084 6.35568 9.72301 6.26316 9.84284 6.26316C9.96267 6.26316 10.0548 6.35567 10.0548 6.47595V6.97555C10.0548 7.09582 9.96267 7.18834 9.84284 7.18834Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6826 7.18834C11.5627 7.18834 11.4706 7.09582 11.4706 6.97555V6.47595C11.4706 6.35568 11.5627 6.26316 11.6826 6.26316C11.8024 6.26316 11.9038 6.35567 11.9038 6.47595V6.97555C11.9038 7.09582 11.8024 7.18834 11.6826 7.18834Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.38294 8.93442C5.26312 8.93442 5.16175 8.83265 5.16175 8.71239V8.2128C5.16175 8.09252 5.26313 8 5.38294 8C5.50276 8 5.59494 8.09252 5.59494 8.2128V8.71239C5.59494 8.83266 5.50277 8.93442 5.38294 8.93442Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.19873 8.93442C7.07891 8.93442 6.97753 8.83265 6.97753 8.71239V8.2128C6.97753 8.09252 7.07892 8 7.19873 8C7.31854 8 7.41073 8.09252 7.41073 8.2128V8.71239C7.41073 8.83266 7.31856 8.93442 7.19873 8.93442Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.07717 8.93442C8.95735 8.93442 8.86517 8.83265 8.86517 8.71239V8.2128C8.86517 8.09252 8.95734 8 9.07717 8C9.19699 8 9.28917 8.09252 9.28917 8.2128V8.71239C9.28917 8.83266 9.19699 8.93442 9.07717 8.93442Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9648 8.93442C10.845 8.93442 10.7528 8.83265 10.7528 8.71239V8.2128C10.7528 8.09252 10.845 8 10.9648 8C11.0846 8 11.186 8.09252 11.186 8.2128V8.71239C11.186 8.83266 11.0846 8.93442 10.9648 8.93442Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortMiniDisplayPortIcon.displayName = "PortMiniDisplayPortIcon";
